<template>
  <div class="bg-white p-5 homework-page">
    <div>
      <h4>
        Bài tập về nhà buổi {{ lesson_alias || lesson }}
      </h4>
    </div>

    <hr />

    <div
        v-loading="loadingMarkHomework"
        class="modal-fillter-poin"
    >
      <div class="table-responsive overflow-auto mt-3">
        <table
            :aria-busy="loadingMarkHomework"
            class="table table-bordered text-center homework-table"
        >
          <thead>
          <tr>
            <th scope="col" class="min-w-150px">
              Họ và tên
            </th>

            <th scope="col" class="min-w-100px">
              Buổi học
            </th>

            <th scope="col" class="min-w-100px">
              Phân loại
            </th>

            <th scope="col" class="min-w-100px">
              Mã học viên
            </th>

            <th scope="col" class="min-w-120px">
              Số điện thoại
            </th>

            <th scope="col" class="min-w-160px">
              Trạng thái
            </th>

            <th scope="col" class="min-w-160px">
              Hình thức chấm
            </th>

            <th scope="col" class="min-w-180px">
              Deadline nộp bài tập
            </th>

            <th scope="col" class="min-w-180px">
              Thời gian GV chấm bài
            </th>

            <th scope="col" class="min-w-140px">
              Hành động
            </th>
          </tr>
          </thead>

          <tbody>
          <HomeWork
              v-for="item in orderedHomeworkList"
              :key="getHomeworkKey(item)"
              :homeWork="item"
              :learning_schedule_id="learning_schedule_id"
              :lessonNumber="lesson"
              @reopen-homework="reopenHomework"
              @resetHomework="openResetHomeworkDialog"
          />

          <tr
              v-if="
                !loadingMarkHomework &&
                orderedHomeworkList.length === 0
              "
          >
            <td
                colspan="10"
                class="text-center text-muted py-4"
            >
              Không có dữ liệu bài tập về nhà
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Dialog mở lại BTVN lần 2 -->
    <el-dialog
        :visible.sync="dialog"
        width="30%"
        class="responsive"
        title="Mở lại bài tập về nhà"
        @closed="resetReopenForm"
    >
      <p>Chọn ngày deadline nộp bài</p>

      <el-date-picker
          v-model="dateTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="Chọn ngày deadline nộp bài"
          class="w-100"
          :picker-options="datePickerOptions"
      />

      <div
          v-if="dateTime"
          class="mt-3"
      >
        Deadline học viên cần nộp bài:

        <strong>
          12h00 - {{ dateTime }}
        </strong>
      </div>

      <div class="d-flex flex-row-reverse mt-4">
        <button
            type="button"
            class="btn btn-success ml-3"
            :disabled="!dateTime || loadingReopen"
            @click="submitReopenHomework"
        >
          <i
              v-if="loadingReopen"
              class="fas fa-spinner fa-spin mr-1"
          />

          Xác nhận
        </button>

        <button
            type="button"
            class="btn btn-secondary"
            :disabled="loadingReopen"
            @click="dialog = false"
        >
          Hủy
        </button>
      </div>
    </el-dialog>

    <ResetHomeworkMarkDialog
        :visible.sync="resetDialog"
        :student-name="resetHomeworkData.name"
        :loading="resetLoading"
        @confirm="submitResetHomework"
    />
  </div>
</template>

<script>
import moment from 'moment'

import HomeWork from './components/HomeWork.vue'
import ResetHomeworkMarkDialog from "./components/ResetHomeworkMarkDialog.vue";

import {
  SET_BREADCRUMB
} from '@/core/services/store/breadcrumbs.module'

import {
  ADMIN_ALL_HOMEWORK,
  REOPEN_HOMEWORK,
  RESET_HOMEWORK_MARK,
  RESET_HOMEWORK_MARK_V2
} from '@/core/services/store/course/classes.module'

const HOMEWORK_ATTEMPT = {
  FIRST: 'btvn_first',
  SECOND: 'btvn_second'
}

export default {
  name: 'ListAllHomeworkStudent',

  components: {
    ResetHomeworkMarkDialog,
    HomeWork
  },

  data() {
    return {
      lesson: null,
      lesson_alias: null,
      classroom_id: null,
      learning_schedule_id: null,

      homeWorkList: [],

      loadingMarkHomework: false,
      loadingReopen: false,

      dialog: false,
      dateTime: '',
      dataReopen: null,

      resetDialog: false,
      resetLoading: false,
      resetHomeworkData: {},

      datePickerOptions: {
        disabledDate(time) {
          return moment(time).isSameOrBefore(
              moment(),
              'day'
          )
        }
      }
    }
  },

  computed: {
    orderedHomeworkList() {
      const firstList = []
      const secondList = []
      const otherList = []

      this.homeWorkList.forEach(item => {
        switch (item.homework_attempt) {
          case HOMEWORK_ATTEMPT.FIRST:
            firstList.push(item)
            break

          case HOMEWORK_ATTEMPT.SECOND:
            secondList.push(item)
            break

          default:
            otherList.push(item)
        }
      })

      return [
        ...firstList,
        ...secondList,
        ...otherList
      ]
    }
  },

  mounted() {
    this.initializePage()
  },

  methods: {
    initializePage() {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: 'Chi tiết lớp học',
          route: 'schedule-class'
        },
        {
          title: 'Danh sách lớp học'
        }
      ])

      const {
        lesson,
        lesson_alias,
        classroom_id,
        learning_schedule_id
      } = this.$route.query

      this.lesson = lesson
      this.lesson_alias = lesson_alias
      this.classroom_id = classroom_id
      this.learning_schedule_id =
          learning_schedule_id

      this.getListHomework()
    },

    getHomeworkKey(item) {
      return [
        item.homework_attempt,
        item.course_student_id,
        item.user_id
      ].join('-')
    },

    async getListHomework() {
      this.loadingMarkHomework = true

      try {
        const response = await this.$store.dispatch(
            ADMIN_ALL_HOMEWORK,
            {
              classroom_id: this.classroom_id,
              lesson: this.lesson,
              type: 'homework'
            }
        )

        if (response && response.error) {
          this.homeWorkList = []

          this.$message.error(
              response.message ||
              'Không thể lấy danh sách bài tập về nhà'
          )

          return
        }

        this.homeWorkList = Array.isArray(response.data)
            ? response.data
            : []
      } catch (error) {
        console.error(
            'Get homework list error:',
            error
        )

        this.homeWorkList = []

        this.$message.error(
            'Có lỗi xảy ra khi lấy danh sách bài tập về nhà'
        )
      } finally {
        this.loadingMarkHomework = false
      }
    },

    reopenHomework(homework) {
      if (!homework) {
        return
      }

      this.dataReopen = homework
      this.dateTime = ''
      this.dialog = true
    },

    async submitReopenHomework() {
      if (!this.dateTime) {
        this.$message.warning(
            'Vui lòng chọn ngày deadline nộp bài'
        )

        return
      }

      if (!this.dataReopen) {
        this.$message.error(
            'Không tìm thấy thông tin học viên'
        )

        return
      }

      const payload = {
        class_id: this.classroom_id,
        lesson: this.lesson,
        deadline: this.dateTime,
        type: this.dataReopen.type,
        student_register_id:
        this.dataReopen.course_student_id
      }

      this.loadingReopen = true

      try {
        const response = await this.$store.dispatch(
            REOPEN_HOMEWORK,
            payload
        )

        if (response && response.error) {
          this.$message.error(
              response.message ||
              'Không thể mở lại bài tập về nhà'
          )

          return
        }

        this.$message({
          type: 'success',
          message: 'Mở lại bài tập về nhà thành công!',
          showClose: true
        })

        this.dialog = false

        await this.getListHomework()
      } catch (error) {
        console.error(
            'Reopen homework error:',
            error
        )

        this.$message.error(
            'Có lỗi xảy ra khi mở lại bài tập về nhà'
        )
      } finally {
        this.loadingReopen = false
      }
    },

    resetReopenForm() {
      this.dateTime = ''
      this.dataReopen = null
    },

    openResetHomeworkDialog(homeWork) {
      this.resetHomeworkData = homeWork;
      this.resetDialog = true;
    },
    submitResetHomework() {
      if (!this.resetHomeworkData.test) {
        return;
      }

      this.resetLoading = true;
      let RESET_HOMEWORK = 'RESET_HOMEWORK_MARK'
      switch (this.resetHomeworkData.homework_attempt) {
        case 'btvn_first':
          RESET_HOMEWORK = RESET_HOMEWORK_MARK;
          break;
        case 'btvn_second':
          RESET_HOMEWORK = RESET_HOMEWORK_MARK_V2;
          break;
      }

      this.$store.dispatch(RESET_HOMEWORK, {
        overall_result_id: this.resetHomeworkData.test.overall_id
      }).then((res) => {
        if (res.error) {
          this.$message({
            type: 'error',
            message: res.message || 'Reset kết quả chấm thất bại!',
            showClose: true
          });
          return;
        }

        this.$message({
          type: 'success',
          message: 'Reset kết quả chấm thành công!',
          showClose: true
        });
        return this.getListHomework().then(() => {
          this.resetDialog = false;
          this.resetHomeworkData = {};
        });
      }).catch((e) => {
        const message = e?.data?.message || 'Reset kết quả chấm thất bại!';
        this.$message({
          type: 'error',
          message,
          showClose: true
        });
      }).finally(() => {
        this.resetLoading = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.homework-page {
  border: 1px solid grey;
}

.homework-table {
  white-space: nowrap;

  th,
  td {
    vertical-align: middle;
  }
}

.min-w-100px {
  min-width: 100px;
}

.min-w-120px {
  min-width: 120px;
}

.min-w-140px {
  min-width: 140px;
}

.min-w-150px {
  min-width: 150px;
}

.min-w-160px {
  min-width: 160px;
}

.min-w-180px {
  min-width: 180px;
}
</style>